import { render, staticRenderFns } from "./addAppCom.vue?vue&type=template&id=4b637c1a"
import script from "./addAppCom.vue?vue&type=script&lang=js"
export * from "./addAppCom.vue?vue&type=script&lang=js"
import style0 from "./addAppCom.vue?vue&type=style&index=0&id=4b637c1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports